var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddress(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 19.818 27.361",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_2352",
    "data-name": "Path 2352",
    d: "M80.482,0a9.92,9.92,0,0,0-9.909,9.909c0,6.781,8.868,16.735,9.245,17.156a.893.893,0,0,0,1.328,0c.378-.42,9.245-10.375,9.245-17.156A9.92,9.92,0,0,0,80.482,0Zm0,14.894a4.985,4.985,0,1,1,4.985-4.985A4.991,4.991,0,0,1,80.482,14.894Z",
    transform: "translate(-70.573)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddress);
export default __webpack_public_path__ + "static/media/address.322fd51952ecb2da1bf867708d4cd3dd.svg";
export { ForwardRef as ReactComponent };